<div class="login-wrapper">
  <div class="stars-bg"></div>
  <div class="stars-fg"></div>

  <div class="login-container card-glass p-5 shadow-lg">
    <h2 class="text-center text-white mb-4 animate-fade-in-glow">
      Welcome Back
    </h2>

    <form>
      <div class="form-floating mb-3 animate-float-in delay-1">
        <input type="text" class="form-control bg-dark text-white border-0 shadow-sm" id="username"
          placeholder="Username" [(ngModel)]="username" name="username" />
          <label for="username" class="text-white">Username</label>
        </div>

        <div class="form-floating mb-3 animate-float-in delay-2">
          <input type="password" class="form-control bg-dark text-white border-0 shadow-sm" id="password"
            placeholder="Password" [(ngModel)]="password" name="password" />
            <label for="password" class="text-white">Password</label>
          </div>

          <div class="d-grid gap-2 mt-4 animate-float-in delay-3">
            <button type="submit" class="btn btn-neon py-2" (click)="onLogin()">Login</button>
            <button type="button" class="btn btn-outline-light py-2" (click)="goToRegister()">Not a user?
            Register</button>
            <!-- <a href="#" class="text-light text-center mt-2 d-block" (click)="openForgotPassword()">Forgot Password?</a> -->

          </div>


        </form>


      </div>

    </div>


    <!-- Forgot Password Modal -->
    <!-- @if (showForgotModal) {
      <div class="modal-backdrop">
        <div class="modal card-glass p-4">
          <h4 class="text-white mb-3">Reset Password 🔒</h4>
          @if (!otpSent) {
            <div>
              <input
                type="email"
                class="form-control mb-3 bg-dark text-white"
                placeholder="Enter your email"
                [(ngModel)]="email"
                />
                <button type="button" class="btn btn-neon w-100 mb-2" (click)="sendOtp()">Send OTP</button>
              </div>
            }
            @if (otpSent && !otpValidated) {
              <div>
                <input
                  type="text"
                  class="form-control mb-3 bg-dark text-white"
                  placeholder="Enter OTP"
                  [(ngModel)]="otp"
                  />
                  <button class="btn btn-outline-light w-100 mb-2" (click)="validateOtp()">Validate OTP</button>
                  @if (otpAttempts >= 3) {
                    <div class="text-danger mt-2">🚫 Too many attempts! Try again after 1 hour.</div>
                  }
                </div>
              }
              @if (otpValidated) {
                <div>
                  <input
                    type="password"
                    class="form-control mb-3 bg-dark text-white"
                    placeholder="Enter new password"
                    [(ngModel)]="newPassword"
                    />
                    <button type="button" class="btn btn-success w-100" (click)="updatePassword()">Update Password</button>
                  </div>
                }
                <button type="button" title="close modal" class="btn-close position-absolute top-0 end-0 m-3" (click)="closeModal()"></button>
              </div>
            </div>
          } -->

         <app-spinner [show]="spinner" [message]="spinMessage" />
